import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { addTaxFormSchema } from './add-tax-form.schema'

export const useAddTaxForm = () => {
  return useForm({
    resolver: yupResolver(addTaxFormSchema),
    defaultValues: addTaxFormSchema.cast({}),
  })
}
